/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
import {
    map,
    concat,
} from 'lodash';

import {
    SEARCH_FIELDS, // 搜索字段
    getSearchFieldsByServiceArea,
    ANALYSIS_FIELDS, // 检索字段
    LOGIC_FIELDS,
    DEFAULT_FIELDS,
    DEFAULT_SYNTAX_VALUES,
    RANGE_SAMPLE,
    RANGE_SAMPLE_SHORT,
    DATE_SAMPLE,
    DATE_Y_SAMPLE,
    DATE_YM_SAMPLE,
} from './fieldConfig'; // 搜索字段和分析字段

import {
    getRDSearchFieldsByServiceArea,
    RD_SEARCH_FIELDS,
} from './rdFieldConfig';
import {
    SYNTAX_VALUES,
} from './syntaxValueConfig';

const SUPPORT_KEYWORDS_FIELDS = ['TTL', 'ABST', 'CLMS', 'ICLMS', 'DESC', 'TAC', 'TA', 'TACD', 'TTL_ENTRANS', 'ABST_ENTRANS', 'CLMS_ENTRANS', 'TTL_CNTRANS', 'ABST_CNTRANS', 'CLMS_CNTRANS', 'TTL_ALL', 'ABST_ALL', 'CLMS_ALL', 'DESC_ALL', 'TA_ALL', 'TAC_ALL', 'TACD_ALL', 'DESC_F', 'DESC_B', 'DESC_S', 'DESC_D', 'DESC_E']; // 提示关键字字段
const DATE_TYPE_FIELDS = ['PBD', 'PBD_Y', 'PBD_YM', 'APD', 'APD_Y', 'APD_YM', 'PRIORITY_DATE', 'ISD', 'EXDT', 'PCTENTRY_DATE', 'VERDICT_DATE', 'HEARING_DATE', 'LIC_EFDT', 'RIDDT', 'PLE_EFDT', 'LIT_FILEDT', 'LIT_CLOSEDT', 'EXAMINE_DATE', 'TRANS_EFDT', 'LEGAL_STATUS_DATE', 'F_PBD', 'E_PRIORITY_DATE', 'FILING_DATE']; // 时间范围字段
const DATE_Y_TYPE_FIELDS = ['PBD_Y', 'APD_Y'];
const DATE_YM_TYPE_FIELDS = ['PBD_YM', 'APD_YM'];
const RANGE_TYPE_FIELDS = ['PV', 'CLAIM_COUNT', 'CITES_COUNT', 'CITEDBY_COUNT', 'FAM_COUNT', 'IFAM_COUNT', 'EFAM_COUNT', 'AN_COUNT', 'ANC_COUNT', 'PAGE_COUNT', 'EXAMINE_PERIOD', 'IN_COUNT', 'CPC_COUNT', 'IPC_COUNT', 'PRIORITY_COUNTRY_COUNT', 'EPDS_COUNT']; // 数字范围字段,目前只有pv需要1 to 50000
const SUPPORT_GNAME_FIELDS = ['GNAME'];
// 分类号支持范围搜索
const RANGE_IPC_CPC_FIELDS = ['IPC', 'CPC', 'MIPC', 'MCPC'];
const RANGE_LOC_FIELDS = ['LOC'];
// 暂时不支持 FTERM 和 UPC
// const RANGE_FTERM_FIELDS = ['FTERM'];
// const RANGE_UPC_FIELDS = ['UPC'];
const RANGE_CLASSIFICATION_FIELDS = [...RANGE_IPC_CPC_FIELDS, ...RANGE_LOC_FIELDS];

// 虽然是RANGE_TYPE_FIELDS中的子类，但是需要不同的推荐示例.需要同时在父级和子级中同时配置
const RANGE_TYPE_FIELDS_SHORT = ['CLAIM_COUNT', 'CITES_COUNT', 'CITEDBY_COUNT', 'FAM_COUNT', 'IFAM_COUNT', 'EFAM_COUNT', 'AN_COUNT', 'ANC_COUNT', 'PAGE_COUNT', 'EXAMINE_PERIOD', 'IN_COUNT', 'CPC_COUNT', 'IPC_COUNT', 'PRIORITY_COUNTRY_COUNT'];

// 支持TREE@的字段
const SUPPORT_TREE_FIELDS = ['ANS', 'ANCS', 'ALL_AN'];

// workspace相关字段
const WORKSPACE_FIELDS = ['MWS', 'CWS'];

// 逻辑词和占位符最大个数配置项
const MAX_LOGIC_LIMIT = 1024;
const MAX_PLACE_SYMBOL_LIMIT = 15;
const MAX_FREQ_LIMIT = 50;

// 合并搜索字段和分析字段用于检测字段合法性
const getFieldList = (isRDVersion = false) => {
    // eslint-disable-next-line no-underscore-dangle
    const _SEARCH_FIELDS = isRDVersion ? getRDSearchFieldsByServiceArea() : getSearchFieldsByServiceArea();
    const fieldList = concat(_SEARCH_FIELDS, ANALYSIS_FIELDS);
    const fieldArr = map(fieldList, (item) => item.name);
    return fieldArr;
};

export {
    SEARCH_FIELDS,
    RD_SEARCH_FIELDS,
    getSearchFieldsByServiceArea,
    getRDSearchFieldsByServiceArea,
    LOGIC_FIELDS,
    DEFAULT_FIELDS,
    DEFAULT_SYNTAX_VALUES,
    getFieldList,
    DATE_TYPE_FIELDS,
    RANGE_TYPE_FIELDS,
    SUPPORT_GNAME_FIELDS,
    SUPPORT_KEYWORDS_FIELDS,
    RANGE_SAMPLE,
    RANGE_SAMPLE_SHORT,
    DATE_SAMPLE,
    DATE_Y_SAMPLE,
    DATE_YM_SAMPLE,
    DATE_Y_TYPE_FIELDS,
    DATE_YM_TYPE_FIELDS,
    SYNTAX_VALUES,
    RANGE_TYPE_FIELDS_SHORT,
    SUPPORT_TREE_FIELDS,
    WORKSPACE_FIELDS,
    MAX_LOGIC_LIMIT,
    MAX_PLACE_SYMBOL_LIMIT,
    MAX_FREQ_LIMIT,
    RANGE_IPC_CPC_FIELDS,
    RANGE_LOC_FIELDS,
    //   RANGE_FTERM_FIELDS,
    //   RANGE_UPC_FIELDS,
    RANGE_CLASSIFICATION_FIELDS,
};
